// extracted by mini-css-extract-plugin
export default {"prizeCont":"Prizes_prizeCont__UqyrF","prize":"Prizes_prize__0m1Rg","prizeH1":"Prizes_prizeH1__nc+3I","prizeDesc":"Prizes_prizeDesc__tP0AP","boxRow":"Prizes_boxRow__bv9pi"};